import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Config from './config'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import store from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import yfxCloudAuth from '@yodatech/vue-yfx-cloud-auth'
import VueYfxLicense from "@yodatech/vue-yfx-license";

Vue.use(require('vue-moment'));
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.$config = Config
Vue.use(yfxCloudAuth, {axios: axios, store: store, serviceName: "auth", ...Config.authConfig})
Vue.use(VueYfxLicense, {axios: axios})

new Vue({
	router,
	vuetify,
	store,
	render: h => h(App)
}).$mount('#app')
